import { reactive } from 'vue'
import { state } from './stateResults'
import { HttpClass } from '../../../shared/http/HttpClass';

// EXPORT
export const storeResults = reactive({
    
    async fetchResults(eventID, widgetID) {
        const ecWidgetDataUrl = "https://election-center-api.coxnewspapers.com/api/v1/events/"+eventID+"/?filterRacesByWidgetId="+widgetID;

        const http = new HttpClass({
            useCacher: true,
            cacherLabel: 'cfm_ec_results_'+widgetID,
            cacherUrl: ecWidgetDataUrl,
            cacherForceReload: false,
            cacherTimeout: 2 // minutes
        });

        const cacherUrl = http.buildCacherUrl();

        // MAKE REQUEST
        const res = await http.sendRequest(cacherUrl);

        return res;
    },

    state

});